import type { CatalogView } from "@ext/catalog/views/models/CatalogViews";
import type TabAttrs from "@ext/markdown/elements/tabs/model/TabAttrs";
import getVisibleTabs from "@ext/markdown/elements/tabs/render/logic/getVisibleTabs";

const getRenderedTabIndexes = (childAttrs: TabAttrs[], view: CatalogView | undefined, isEdit: boolean): number[] => {
	const visible = getVisibleTabs(childAttrs, view).indexes;
	if (visible.length || !isEdit) return visible;
	return childAttrs.map((_, index) => index);
};

export const shouldHideSingleCase = (visibleCount: number, view: CatalogView | undefined, isEdit: boolean): boolean =>
	visibleCount === 1 && !!view && !isEdit;

export default getRenderedTabIndexes;
